var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 16,
    viewBox: "0 0 67 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2071 7.42717C66.5976 7.81769 66.5976 8.45086 66.2071 8.84138L59.8431 15.2053C59.4526 15.5959 58.8195 15.5959 58.4289 15.2053C58.0384 14.8148 58.0384 14.1817 58.4289 13.7911L64.0858 8.13428L58.4289 2.47742C58.0384 2.0869 58.0384 1.45373 58.4289 1.06321C58.8195 0.672685 59.4526 0.672685 59.8431 1.06321L66.2071 7.42717ZM1 9.13428C0.447716 9.13428 0 8.68656 0 8.13428C0 7.58199 0.447716 7.13428 1 7.13428V9.13428ZM65.5 9.13428H1V7.13428H65.5V9.13428Z",
    fill: "url(#paint0_radial_68_3131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_68_3131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.1606 8.13428) rotate(178.484) scale(46.9614 2.28137)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8FF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#95FB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8FF01"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultArrow);
export default __webpack_public_path__ + "static/media/default-arrow.42b0399f70c366ad8b695d147c25e45b.svg";
export { ForwardRef as ReactComponent };